import React from 'react';

import DefaultLayout from './DefaultLayout';
import WithTracking from '../WithTracking';

const DefaultLayoutWithTracking = props => (
  <WithTracking {...props}>
    <DefaultLayout {...props} />
  </WithTracking>
);

export default DefaultLayoutWithTracking;
